<template>

    <div class="panel live-session" :class="{'sidebar-widget': location==='sidebar'}">
        {{date}}
        <div class="panel-heading"><h2><img src="../../assets/img/live-qa-icon.png">Next Live Session<i class="clippie fa fa-info-circle" v-tooltip="'Your next live session countdown.'"></i></h2></div>
        <div class="panel-body" v-if="isOngoing || meetings || nextGlobalMeeting">

            <div class="next-meeting" v-if="nextMeeting && nextMeeting !== Infinity && (noUpcomingMeeting==false || isOngoing)">
                <span class="time" v-if="!isPastSemester">{{nextMeeting.startTime | longDate}}</span>
                <span class="meeting-name" v-if="nextMeeting.name">{{nextMeeting.name}}</span>
                <span v-else class="meeting-name">Live Session</span>

                <div class="countdown"
                     v-if="!isPastSemester
                     && !localStorage.roles.includes('CampusStudent')
                     && localStorage.transitioned != 'true'
                     ">

                    <countdown
                        v-if="!isOngoing"
                        :duration="nextMeeting.duration"
                        :date="nextMeeting.startTime"
                        :isForMeeting="true"
                        />

                       <span v-else class="countdown"><span class="join-session">Join Session</span></span>

                    <a
                        v-if="isAvailable(nextMeeting.startTime)"
                        @mousedown="recordAttendance(nextMeeting)"
                        class="join"
                        :href="nextMeeting.joinUrl"
                        target="_blank">Join</a>
                    <a v-else
                        :href="nextMeeting.joinUrl"
                        target="_blank"
                        class="join disabled">
                            Join
                        </a>
                </div>

                <div class="countdown"
                v-if="!isPastSemester
                && (localStorage.roles.includes('CampusStudent')
                || localStorage.transitioned == 'true')">
                    <countdown
                        v-if="isOngoing!==true"
                        :duration="nextMeeting.duration"
                        :isForMeeting="true"
                        :date="nextMeeting.startTime"></countdown>
                    <div v-if="nextMeeting.zoomId">
                        <a
                            v-if="isAvailable(nextMeeting.startTime)"
                            @mousedown="recordAttendance(nextMeeting)"
                            class="join"
                            :href="nextMeeting.joinUrl"
                            target="_blank">Join</a>
                        <a v-else
                            :href="nextMeeting.joinUrl"
                            target="_blank"
                            class="join disabled">
                                Join
                            </a>
                    </div>
                </div>
            </div>

            <div v-if="(!nextMeeting || nextMeeting === Infinity) && noUpcomingMeeting === true && !nextGlobalMeeting">
                <div class="next-meeting text-center">
                    No Meetings scheduled
                </div>
            </div>

            <div class="next-meeting next-global-meeting" v-if="nextGlobalMeeting && location === 'sidebar'">
                <span class="time"
                    v-if="!isPastSemester">{{nextGlobalMeeting.startTime | longDate}}
                </span>
                <span class="meeting-name"
                    @click="selectedGlobalMeeting = nextGlobalMeeting">
                        {{nextGlobalMeeting.name}} <br> ({{nextGlobalMeeting.global_meeting_participants.length}} / {{nextGlobalMeeting.maxParticipants}})
                </span>

                <div class="countdown"
                    v-if="!isPastSemester
                    && !localStorage.roles.includes('CampusStudent')">

                    <countdown
                        v-if="!ongoingMeeting(nextGlobalMeeting.startTime)"
                        :duration="nextGlobalMeeting.duration"
                        :date="nextGlobalMeeting.startTime"
                        :isForMeeting="true"
                        />

                    <span v-else class="countdown"><span class="join-session">Join Session</span></span>

                    <div class="buttons">
                        <span v-if="!isWaitListed(nextGlobalMeeting)">
                            <a
                            v-if="isAvailable(nextGlobalMeeting.startTime)"
                            @mousedown="recordAttendance(nextGlobalMeeting)"
                            class="join"
                            :href="nextGlobalMeeting.joinUrl"
                            target="_blank">
                                <span v-if="nextGlobalMeeting.mentor.id == localStorage.user_id">Start</span>
                                <span v-else>Join</span>
                            </a>
                            <a
                                v-else
                                :href="nextGlobalMeeting.joinUrl"
                                target="_blank"
                                class="join disabled">
                                    <span v-if="nextGlobalMeeting.mentor.id == localStorage.user_id">Start</span>
                                    <span v-else>Join</span>
                            </a>
                        </span>

                        <button
                            @click.prevent="optOut(nextGlobalMeeting.id)"
                            v-if="nextGlobalMeeting.mentor.id != localStorage.user_id"
                            :class="{'disabled': optOutCutoffPassed}"
                            class="opt-out btn btn-danger">
                                Opt Out
                        </button>
                    </div>
                </div>
                <div class="countdown" v-if="!isPastSemester && localStorage.roles.includes('CampusStudent')">
                    <countdown
                        v-if="isOngoing!==true"
                        :isForMeeting="true"
                        :duration="nextGlobalMeeting.duration"
                        :date="nextGlobalMeeting.startTime"></countdown>
                </div>
            </div>


            <div v-if="selectedGlobalMeeting">
                <global-meeting-participants
                        v-if="roles.includes('GlobalMentor') || roles.includes('Recruiter')"
                        :participants="selectedGlobalMeeting.global_meeting_participants"
                        :link="selectedGlobalMeeting.joinUrl"
                        :recordingProcessing="false"
                        :hasRecording="false"
                        :maxParticipants="selectedGlobalMeeting.maxParticipants"
                        @closeModal="selectedGlobalMeeting=null"
                         />

                <global-meeting-signup
                    v-else
                    :meetingId="selectedGlobalMeeting.id"
                    @closeModal="selectedGlobalMeeting=null"
                    />

             </div>

              <VuePerfectScrollbar class="scroll-area next-live-session" v-if="location !== 'sidebar'">

                <ul class="archives">
                    <li v-for="(meeting,index) in meetings" class="clearfix" v-if="isInPast(meeting.startTime, meeting.duration)">
                        <div class="col-xs-6">
                            Week {{meetingWeek(meeting.startTime)}}
                        </div>
                        <div class="col-xs-6 text-right">
                            <a class="no-archive" v-if="!meeting.archiveUrl">No Archive</a>
                            <a class="processing" v-if="meeting.archiveUrl && meeting.archiveStatus === 'processing'">
                                Archive Processing
                            </a>
                            <div v-if="meeting.archiveUrl && meeting.archiveStatus === 'completed'" :href="meeting.archiveUrl" target="_blank">
                                <a :href="meeting.archiveUrl" target="_blank" >Live Session Archive</a>
                                <span v-if="meeting.secondaryRecordings && meeting.secondaryRecordings.length > 0">
                                    (
                                    <a :href="meeting.archiveUrl" target="_blank">1</a>
                                     <span v-for="(recording, index) in meeting.secondaryRecordings">,
                                        <a :href="recording" target="_blank"> {{ index + 2 }} </a>
                                    </span>)
                                </span>
                            </div>
                        </div>
                   </li>
               </ul>
           </VuePerfectScrollbar>
       </div>
       <div v-else class="panel-body text-center"><p>No meetings scheduled yet</p></div>
   </div>

</template>


<script>
    import users from '../../services/users';
    import meetings from '../../services/meetings';
    import globalMeetings from '../../services/global-meetings';
    import countdown from '../reusable/countdown/CountdownTimer.vue';

    import moment from 'moment';
    import toastr from 'toastr';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import GlobalMeetingParticipants from './GlobalMeetingParticipants';
    import GlobalMeetingSignup from './GlobalMeetingSignup';

    export default {
        props: ['location'],
        data() {
            return {
                meetings:null,
                groups: null,
                nextMeeting: null,
                nextGlobalMeeting: null,
                currentWeek: null,
                layout: null,
                noTerm: false,
                isOngoing: true,
                noUpcomingMeeting: false,
                isPastSemester: false,
                selectedGlobalMeeting: null,
            }
        },
        components: {
            countdown,
            VuePerfectScrollbar,
            GlobalMeetingParticipants,
            GlobalMeetingSignup
        },
        async mounted() {
            // this.$bus.$on('reloadGlobalMeetings', () => {
            //     this.getGroups();
            // });
            var self = this;
            if (localStorage.terms == 'null') {
                this.noTerm = true;
            } else {

                this.getGroups();
                this.currentWeek = this.$store.getters.currentWeek;

            }
            this.$bus.$on('meeting_started', function() {
                self.meetings = null;
                self.isOngoing = true;
                window.location.reload();
                // self.getGroups();
            });
        },
        watch: {
            '$store.getters.currentTerm'(term) {
                if (!term) return;
                this.getGroups();
            }
        },
        methods: {
        ongoingMeeting(startTime) {
            return new Date(startTime) < new Date();
        },
        optOut(meetingId) {
            if (this.optOutCutoffPassed) return false;
            globalMeetings.toggleSignup(meetingId, false).then((response)=> {
                this.nextGlobalMeeting = null;
                window.location.reload();
                // this.$bus.$emit('reloadGlobalMeetings');
            });
        },
        recordAttendance(meeting) {

            if (meeting.global === true) {
                globalMeetings.recordAttendance(meeting.id);
            }
            else {
                meetings.recordAttendance(meeting.id);
            }

        },
        isInPast(time, duration) {
            return moment(time).add(duration).toDate() < new Date()
        },
        getGroups() {
            var self = this;
            
            users.getGroups(this).then(function(response) {
                if (response.data && response.data.groups) {
                    self.groups = response.data.groups;
                    self.$store.dispatch('populate', {type: 'groups', data: response.data.groups});
                    self.getMeetings();
                } else {
                    self.getMeetings();
                }
            });
        },

        findNextMeeting(meetings) {

                meetings = meetings.sort((a,b) => { return new Date(a.startTime) - new Date(b.startTime); });

                const now = Date.now();

                var ongoing = null;

                var nextMeeting = Infinity;

                meetings.forEach(function(m) {


                    var d = new Date(m.startTime);
                    let endTime;
                    if (m.endTime) {
                        endTime = moment(m.endTime);
                    } else {
                        endTime = moment(m.startTime).add(m.duration,'minutes');
                    }

                    if (moment(Date.now()).isBetween(moment(m.startTime), endTime)) {
                        self.isOngoing = true;
                        // meeting is happening right now
                        ongoing = m;
                    } else {
                        if (d >= now && d < nextMeeting) {

                            nextMeeting = m;
                        }
                    }
                });
                if (ongoing) {
                    return ongoing;
                }
                else {
                    return nextMeeting;
                }

        },
        async getMeetings() {
            var self = this;
            self.meetings = null;
            self.noUpcomingMeeting = false;
            self.isOngoing = false;
            let studentGroups = localStorage.group.split(',').map(function(i) { return parseInt(i)});
            let currentTerm = this.$store.getters.currentTerm;

            let currentTermGroup = 0;

            if (!localStorage.roles.includes('GlobalMentor') && !localStorage.roles.includes('Recruiter')) {
                if (currentTerm) {
                    
                    if (!this.groups) { this.groups = [] }

                    currentTermGroup = this.groups.findIndex(function(g) {
                        return g.term == currentTerm.id && studentGroups.indexOf(g.id) > -1
                    });
                    if (this.groups[currentTermGroup]) {
                        currentTermGroup = this.groups[currentTermGroup].id;
                    }
                }

            }

            if (self.isMentorshipStudent || self.roles.includes('GlobalMentor') || self.roles.includes('Recruiter')) {
                let globals = await globalMeetings.getMine();

                if (self.isMentorshipStudent) {
                    globals = globals.data.meetings.map((m)=> {

                        let meetingType = 'Global Mentorship';
                        if (m.global_meeting && m.global_meeting.mentor.roles.includes('Recruiter')) meetingType = 'Recruiter';
                        else if (m.mentor && m.mentor.roles.includes('Recruiter')) meetingType = 'Recruiter';

                        m.global_meeting.name = meetingType + ' Meeting, ' + m.global_meeting.mentor.firstName + ' ' + m.global_meeting.mentor.lastName;
                        m.global_meeting.global = true;
                        return m.global_meeting;
                    });
                } else {
                    globals = globals.data.meetings.map((m)=> {
                        let meetingType = 'Global Mentorship';
                        if (m.global_meeting && m.global_meeting.mentor.roles.includes('Recruiter')) meetingType = 'Recruiter';
                        else if (m.mentor && m.mentor.roles.includes('Recruiter')) meetingType = 'Recruiter';

                        m.name = meetingType + ' Meeting';
                        m.global = true;
                        return m;
                    })
                }

                let nextGlobalMeeting = self.findNextMeeting(globals);

                // no participants; meeting is cancelled
                if (moment(nextGlobalMeeting.startTime).diff(new Date(),'hours') >= 11 && nextGlobalMeeting.global_meeting_participants.length === 0) {
                    nextGlobalMeeting = null;
                }

                if (nextGlobalMeeting && nextGlobalMeeting !== Infinity) {
                    nextGlobalMeeting.global = true;
                    self.nextGlobalMeeting = nextGlobalMeeting;
                }
            }


            if (currentTermGroup < 1) return;


            meetings.get(this, currentTermGroup).then(async function(response) {

                if (self.isMentorshipStudent) {
                    response.data.meetings = response.data.meetings.filter((m)=> {
                        return !m.participants || m.participants.includes(parseInt(localStorage.user_id));
                    });
                }

                if (localStorage.venue === 'campus') {
                    response.data.meetings = response.data.meetings.filter((m)=> {
                        return m.zoomId;
                    });
                }

                var now = new Date();
                if (response.data.success === true) {

                    var meetings = response.data.meetings.sort(function(a,b) {
                        return new Date(a.startTime) - new Date(b.startTime)
                    });

                    var nextMeeting = self.findNextMeeting(meetings);

                    self.nextMeeting = nextMeeting;

                    var nextMeetingDate = new Date(nextMeeting.startTime);

                    if (nextMeeting == Infinity) {
                        self.noUpcomingMeeting = true;
                        nextMeetingDate = new Date('2525-01-01');
                    } else {
                        let endTime;

                        if (nextMeeting.endTime) {
                            endTime = moment(nextMeeting.endTime);
                        } else {
                            endTime = moment(nextMeeting.startTime).add(nextMeeting.duration,'minutes');
                        }

                        if (moment(Date.now()).isBetween(moment(nextMeeting.startTime), endTime)) {
                            self.isOngoing = true;
                        }

                        nextMeeting.type = 'meeting';
                        self.$store.dispatch('concat', {type: 'timelineEvents', data: [nextMeeting]});
                    }

                    meetings = meetings.reverse().filter(function(m){
                        return new Date(m.startTime) < nextMeetingDate;
                    });
                    console.log('Got meetings');


                    self.meetings = meetings;

                    if (!localStorage.roles.includes('GlobalMentor') && !self.roles.includes('Recruiter')) {
                        if (new Date(currentTerm.endDate) < new Date()) {
                            self.isPastSemester = true;
                        } else {
                            self.isPastSemester = false;
                        }
                    } else {
                        self.isPastSemester = false;
                    }

                    self.$forceUpdate();
                    self.$nextTick(function() {

                        if (meetings.length < 4) return;
                        setTimeout(function() {
                            let introVideoHeight = $('.intro-video-wrapper').outerHeight();
                            let courseWidgetHeight = $('.course-widget-wrapper').innerHeight();
                            let liveSessionHeight = $('.panel.live-session').innerHeight();
                            let scrollAreaHeight = $('.scroll-area.next-live-session').innerHeight();
                            let newScrollAreaHeight = (courseWidgetHeight - (introVideoHeight + liveSessionHeight));

                            if (newScrollAreaHeight < 0) newScrollAreaHeight = 100;
                            $('.scroll-area').innerHeight((scrollAreaHeight + newScrollAreaHeight) - $('.next-meeting').innerHeight() + 10);
                        },1000)
                    });

                } else {
                  //  toastr.error('No live sessions found');
                }
            })
        },
        isAvailable(startTime) {
            startTime = moment(startTime).local().toDate();
            if (startTime < new Date()) {
                return true;
            }
            return false;
        },
        isWaitListed(meeting) {

            const participant = meeting.global_meeting_participants.find(p => p.userId == localStorage.user_id);
            if (participant && participant.waitListed) {
                return true;
            }
        },
        meetingWeek(startTime) {
                var termStart = this.$store.getters.currentTerm.startDate;
                var diff = moment(startTime).diff(termStart,'weeks');
                return diff + 1;
        },
    },
    computed: {
        optOutCutoffPassed() {
            if (this.nextGlobalMeeting) {
                const diff = moment(this.nextGlobalMeeting.startTime).diff(moment(), 'hours');
                if (diff > 12 ) return false;
            }
            return true;
        },
        isMentorshipStudent() {
            return localStorage.terms.split(',').length > 3;
        },
        roles() {
            return JSON.parse(localStorage.roles);
        }
    }


}

</script>

<style lang="scss">
 .next-meeting .subscript {
    font-size:4rem;
    bottom:-1rem;
    position: relative;
 }

 .sidebar-widget .next-meeting .countdown span{
    font-size:3rem!important;
    display:block;
    margin-bottom:2rem;
    float:none;
 }

    .ps__scrollbar-y {
        background: #444!important;
    }
    .ps__scrollbar-y-rail {
        &, &:hover {
            width:10px!important;
            background-color:#333!important;
        }
    }

</style>

<style lang="scss" scoped>

    .sidebar-widget .next-meeting .countdown a.join span {
        font-size:inherit!important;
        display:inline;
        margin:auto;
    }
    .next-global-meeting .meeting-name {
        cursor:pointer;
    }

    .meeting-name {
        font-size:1.6rem;
        text-align:center;
        display:block;
        margin-top:.5rem;
        color:#3cf;
    }
    .sidebar-widget {
        .time {
            text-align:center;
            display:inline-block;
        }
    }

    .scroll-area {
      position: relative;
      margin: auto;
      width: 100%;
      height: 126px!important;

    }
    .next-meeting .countdown {
        text-align: center;
        span {
            font-size:4rem;
            font-weight:100;
        }
    }
    .live-session {
        h2 img {
            margin-right:1rem;
        }

        .next-meeting {
            padding:2rem;
            padding-bottom: 0;
            .time {
                font-size:1.6rem;
            }

        }
        .archives {
            padding:1rem;
            overflow-y: auto;
            li {
                padding: 1rem;
                border-bottom:1px solid #5b5b5b;
            }
        }
    }

    .opt-out {
        padding:.65rem 1rem;
        top:-12px;
        margin-left:8px;
        position:relative;
        &.disabled {
            cursor: not-allowed;
        }
    }
    .join {
        background: #264b57;
        padding:.5rem 2rem;
        //margin-left: 2rem;
        font-size:2rem;
        color:#fff;
        position:relative;
        top:-.5rem;
        &.disabled {
            color:#24373e;
        }
        &, &:active, &:hover, &:visited {
            text-decoration: none;
        }
    }
    .join-session {
        color:#3feb9b;
    }
    .panel-body > p {
        padding:2rem;
    }
    .buttons {
        display:flex;
        align-items: center;
        justify-content: center;
    }

</style>



// WEBPACK FOOTER //
// NextLiveSession.vue?01c22389